// src/components/steps/NetworkConfigStep.js
import React from 'react';
import NetworkDiagramTooltip from '../NetworkDiagramTooltip';

function NetworkConfigStep({ state, setState, serviceData, exchangeRate, setCurrentStep }) {
  return (
    <div className="space-y-6">
      <div className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">Network Configuration</h2>
        <p className="text-gray-600 mb-4">Configure your network requirements</p>
      </div>
      <div className="space-y-4">
        <div className="p-6 border-2 border-gray-200 rounded-xl">
          <label className="block mb-2 text-lg font-medium text-gray-900">Number of Sites</label>
          <input
            type="number"
            min="0"
            value={state.siteCount}
            onChange={e => setState(prev => ({ ...prev, siteCount: parseInt(e.target.value) || 0 }))}
            className="w-32 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {state.siteCount > 1 && (
          <div className="p-6 border-2 border-gray-200 rounded-xl">
            <div className="flex justify-between items-start">
              <label className="flex items-start cursor-pointer">
                <input
                  type="checkbox"
                  checked={state.centralizedVpn}
                  onChange={e => setState(prev => ({ ...prev, centralizedVpn: e.target.checked }))}
                  className="w-4 h-4 mt-1 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                />
                <div className="ml-3">
                  <span className="block text-lg font-medium text-gray-900">Use Centralized VPN</span>
                  <span className="block text-sm text-gray-500 mb-2">
                    Connect all {state.siteCount} sites through a central location
                  </span>
                  <div className="flex items-center gap-4">
                    <div className="text-sm">
                      <span className="text-green-600 font-medium">Recommended for more than 2 sites</span>
                      {state.siteCount >= 4 && (
                        <span className="ml-2 text-gray-500">
                          (saves ${(((state.siteCount - 1) * serviceData.network.vpn.price) * exchangeRate).toFixed(2)}/month)
                        </span>
                      )}
                    </div>
                    <NetworkDiagramTooltip
                      title={`Multi-Site Network - ${state.centralizedVpn ? 'Centralized' : 'Direct'} VPN`}
                      isCentralized={state.centralizedVpn}
                      siteCount={state.siteCount}
                    />
                  </div>
                </div>
              </label>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default NetworkConfigStep;
